define('app/utils',['require','jquery'],function(require){

  var $ = require('jquery');

  window.shareToFacebook = function(path, title, image, desc){
    var hash = '';
    if(path.toString().indexOf('#') > -1) {
      hash = '#'+path.toString().split('#')[1];
      var preHash = path.toString().split('#')[0];
      path = preHash;
    }

    var encoded = encodeURIComponent(path + (path.indexOf('?') >= 0 ? '&' : '?') + 'fb=1&t=' + title + '&d=' + desc + '&i=' + image + hash);
    window.open('http://www.facebook.com/share.php?u=' + encoded,'_blank','titlebar=no,statusbar=no,menubar=no,scrollbars=no,width=600,height=400');
  };

  window.shareToGoogle = function(path, title, image, desc){
    var hash = '';
    if(path.toString().indexOf('#') > -1) {
      hash = '#' + path.toString().split('#')[1];
      var preHash = path.toString().split('#')[0];
      path = preHash;
    }
    if(path.charAt(path.length - 1) == '?')
      path = path.substr(0,path.length - 2);

    var encoded = encodeURIComponent(path + (path.indexOf('?') >= 0 ? '&' : '?') + 'gp=1&t=' + title + '&d=' + desc + '&i=' + image + hash);
    window.open('https://plus.google.com/share?url=' + encoded,'_blank','titlebar=no,statusbar=no,menubar=no,scrollbars=no,resizeable=no,width=600,height=400');
  };

  window.shareToTwitter = function(url, msg){
    window.open('/twitter-share/?message=' + msg + '&url=' + url.replace('#','%23'),'_blank','titlebar=no,statusbar=no,menubar=no,scrollbars=no,width=600,height=400');
  };

  window.getQueryString = function() {
    var result = {}, queryString = location.search.substring(1);
    var re = /([^&=]+)=([^&]*)/g, m;

    while (m = re.exec(queryString)) {
      result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }

    return result;
  };

  $.expr[':']['ajax-link'] = function(elm, i, match){
    var href = $(elm).data('href') || $(elm).attr('href');
    var target = $(elm).data('target') || $(elm).attr('target');

    if(target && target == '_blank'){
      return false;
    }

    if(href){
      if(href.indexOf('.pdf') >= 0 ||
        href.indexOf('.jpg') >= 0 ||
        href.indexOf('.jpeg') >= 0 ||
        href.indexOf('.png') >= 0 ||
        href.indexOf('.gif') >= 0
      ){ return false; }

      if(href.substr(0, 1) == '/' ||
        (href.indexOf(window.location.hostname) >= 0 && href.indexOf(window.location.hostname) == 0) ||
        (href.indexOf('http://' + window.location.hostname) >= 0) ||
        (href.indexOf('http://www.' + window.location.hostname) >= 0) ||
        (href.indexOf('https://' + window.location.hostname) >= 0) ||
        (href.indexOf('https://www.' + window.location.hostname) >= 0)
      ){ return true; }
    }

    return false;
  };

  jQuery.fn.shuffle = function () {
    var j;
    for (var i = 0; i < this.length; i++) {
      j = Math.floor(Math.random() * this.length);
      $(this[i]).before($(this[j]));
    }
    return this;
  };

  $.fn.nextOrFirst = function(selector){
    var next = this.next(selector);
    return (next.length) ? next : this.prevAll(selector).last();
  };

  $.fn.prevOrLast = function(selector){
    var prev = this.prev(selector);
    return (prev.length) ? prev : this.nextAll(selector).last();
  };

  function getNthIndex(cur, dir) {
    var t = cur, idx = 0;
    while (cur = cur[dir] ) {
      if (t.tagName == cur.tagName) {
        idx++;
      }
    }
    return idx;
  }

  function isNthOf(elm, pattern, dir) {
    var position = getNthIndex(elm, dir), loop;
    if (pattern == 'odd' || pattern == 'even') {
      loop = 2;
      position -= !(pattern == 'odd');
    } else {
      var nth = pattern.indexOf('n');
      if (nth > -1) {
        loop = parseInt(pattern, 10) || parseInt(pattern.substring(0, nth) + '1', 10);
        position -= (parseInt(pattern.substring(nth + 1), 10) || 0) - 1;
      } else {
        loop = position + 1;
        position -= parseInt(pattern, 10) - 1;
      }
    }
    return (loop<0 ? position<=0 : position >= 0) && position % loop == 0
  }

  var pseudos = {
    'first-of-type': function(elm) {
      return getNthIndex(elm, 'previousSibling') == 0;
    },
    'last-of-type': function(elm) {
      return getNthIndex(elm, 'nextSibling') == 0;
    },
    'only-of-type': function(elm) {
      return pseudos['first-of-type'](elm) && pseudos['last-of-type'](elm);
    },
    'nth-of-type': function(elm, i, match) {
      return isNthOf(elm, match[3], 'previousSibling');
    },
    'nth-last-of-type': function(elm, i, match) {
      return isNthOf(elm, match[3], 'nextSibling');
    }
  }

  $.extend($.expr[':'], pseudos);

  /*!
   * jQuery.fn.hasAttr()
   *
   * Copyright 2011, Rick Waldron
   * Licensed under MIT license.
   *
   */
    $.fn.hasAttr = function( name ) {
      for ( var i = 0, l = this.length; i < l; i++ ) {
        if ( !!( this.attr( name ) !== undefined ) ) {
          return true;
        }
      }
      return false;
    };

});
